"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./Header.scss");
const Navigation_1 = require("../Navigation/Navigation");
// may also want some sort of nav bar with skip links to the diff sections.
const Header = () => {
    return (react_1.default.createElement("header", { className: "header" },
        react_1.default.createElement("img", { className: "desktop-logo", src: "images/logos/logo-without-stem/TC3-Red-and-Black.png", alt: "TC3 Logo Desktop" }),
        react_1.default.createElement("img", { className: "mobile-logo", src: "images/logos/die-without-stem/TC3-Cherry-Die.png", alt: "TC3 Logo Mobile" }),
        react_1.default.createElement(Navigation_1.Navigation, null)));
};
exports.default = Header;
